var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 22,
    viewBox: "0 0 28 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3198 1.10906C13.6684 0.307396 14.8054 0.307398 15.1539 1.10906L17.8813 7.38153C18.0401 7.74663 18.4003 7.98278 18.7984 7.98278H26.8447C27.8817 7.98278 28.2332 9.3668 27.3218 9.86161L21.3621 13.0972C20.9064 13.3446 20.7154 13.8993 20.9221 14.3748L23.3046 19.854C23.6838 20.7262 22.7462 21.5854 21.9104 21.1316L14.714 17.2246C14.4164 17.063 14.0573 17.063 13.7598 17.2246L6.56336 21.1316C5.72755 21.5854 4.78994 20.7262 5.16917 19.854L7.55163 14.3748C7.75839 13.8993 7.56739 13.3446 7.1117 13.0972L1.15198 9.86161C0.240577 9.3668 0.592049 7.98278 1.62911 7.98278H9.67538C10.0735 7.98278 10.4337 7.74663 10.5924 7.38153L13.3198 1.10906Z",
    fill: "#B1CA16"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.ee3d12575a883bb9ab3cd3353223772b.svg";
export { ForwardRef as ReactComponent };